export const answerData = {
  data: [
    {
      id: 1,
      publication_id: 1,
      response_parent_id: 0,
      comment: 'Esto es un comentario',
      author: {
        id: 2706,
        picture: 'https://i.pravatar.cc/100',
        lastname: 'Reyes',
        firstname: 'Hernan',
        nickname: 'hernan',
      },
      stats: {
        answers: 2,
        reactions: 5,
      },
      last_reactions: ['PROUD', 'LIKE', 'EXCELLENT'],
      user_reaction: 'LOVE',
      created_at: '2020-10-12T22:49:01.331314Z',
      updated_at: '2021-03-18T11:00:57.840147Z',
    },
    {
      id: 2,
      publication_id: 1,
      response_parent_id: 0,
      comment: 'Esto es un segundo comentario',
      author: {
        id: 169,
        picture: 'https://i.pravatar.cc/300',
        lastname: 'Lozada',
        firstname: 'Alexys',
        nickname: 'alexys',
      },
      stats: {
        answers: 0,
        reactions: 1,
      },
      last_reactions: ['PROUD'],
      user_reaction: '',
      created_at: '2020-10-12T22:49:01.331314Z',
      updated_at: '2021-03-18T11:00:57.840147Z',
    },
  ],
  messages: [
    {
      type: 'OK',
      code: 'OK',
      message: 'Ok',
      href: '',
    },
  ],
  errors: null,
}
